module.exports = __webpack_public_path__ + "static/img/new-1.a120235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-1.png
// module id = YxnY
// module chunks = 1